module.exports = __webpack_public_path__ + "img/designer_refused.9f951c3e.png";